/**
 * Withdrawal API
 * 출금 관련 API 호출 함수
 */

import { apiClient } from '../../../../core/api/client';
import { 
    WithdrawalAccountResponse,
    WithdrawalRequestRequest,
    WithdrawalRequestResponse,
    TransactionHistoryRequest,
    TransactionHistoryResponse,
} from '../types/withdrawal';

const BASE_PATH = '/api/v1/mob/withdrl';

/**
 * 출금 계좌 정보 조회 API
 * GET /api/v1/mob/withdrl/account
 * @returns 출금 계좌 정보 응답
 */
export const getWithdrawalAccount = async (): Promise<WithdrawalAccountResponse> => {
    const response = await apiClient.get<WithdrawalAccountResponse>(
        `${BASE_PATH}/account`
    );
    return response.data;
};

/**
 * 출금 신청 API
 * POST /api/v1/mob/withdrl/request
 * @param request 출금 신청 요청 데이터
 * @returns 출금 신청 응답
 */
export const requestWithdrawal = async (
    request: WithdrawalRequestRequest
): Promise<WithdrawalRequestResponse> => {
    const response = await apiClient.post<WithdrawalRequestResponse>(
        `${BASE_PATH}/request`,
        request
    );
    return response.data;
};

/**
 * 입출금 내역 조회 API
 * GET /api/v1/mob/withdrl/transactions
 * @param params 입출금 내역 조회 요청 파라미터
 * @returns 입출금 내역 조회 응답
 */
export const getTransactionHistory = async (
    params: TransactionHistoryRequest
): Promise<TransactionHistoryResponse> => {
    const response = await apiClient.get<TransactionHistoryResponse>(
        `${BASE_PATH}/transactions`,
        { params }
    );
    return response.data;
};

